import { Link, Typography, Breadcrumbs } from '@mui/material';
import type { MouseEventHandler } from 'react';

interface BreadcrumbItem {
	text: string;
	onClick?: MouseEventHandler<HTMLButtonElement>;
	dataRoute?: string;
}

interface BreadCrumbProps {
	items: BreadcrumbItem[];
}

export const BreadCrumbs = ({ items }: BreadCrumbProps) => {
	return (
		<Breadcrumbs sx={{ mb: 1 }}>
			<Link
				component="button"
				variant="body1"
				data-route={items[0]?.dataRoute}
				onClick={items[0]?.onClick}
			>
				{items[0]?.text}
			</Link>
			<Typography color="black" variant="body1">
				{items[1]?.text}
			</Typography>
		</Breadcrumbs>
	);
};
